/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

import { fg } from '@atlaskit/platform-feature-flags';
import { UNSAFE_useMediaQuery as useMediaQuery } from '@atlaskit/primitives/responsive';

import { PRIMARY_ACTION_ITEM_INDEX, RESPONSIVE_BREAKPOINT } from '../../../constants';
import { useUniversalCreateState } from '../../../context';
import type { FoldableType } from '../../../types/menu';
import MenuItemV2 from '../MenuItemV2';

export interface PrimaryActionMenuItemProps {
	sectionFoldableBehaviour?: FoldableType;
	sectionItemsCount: number;
	sectionStartIndex: number;
	totalMenuItemsCount: number;
}

/**
 * Renders the primaryActionItem inside the menu on small viewports (sm and below),
 * where the split button trigger is not displayed.
 * Self-contained to isolate breakpoint-driven re-renders from the rest of the menu.
 */
export function PrimaryActionMenuItem({
	sectionItemsCount,
	sectionStartIndex,
	totalMenuItemsCount,
	sectionFoldableBehaviour,
}: PrimaryActionMenuItemProps) {
	const { primaryActionItem } = useUniversalCreateState();
	const isMobile = !(useMediaQuery(`above.${RESPONSIVE_BREAKPOINT}`)?.matches ?? false);

	if (
		!isMobile ||
		!primaryActionItem ||
		!fg('navx_uc_enable_primary_item_in_responsive_dropdown')
	) {
		return null;
	}

	return (
		<MenuItemV2
			item={primaryActionItem}
			itemIndex={PRIMARY_ACTION_ITEM_INDEX}
			sectionStartIndex={sectionStartIndex}
			sectionItemsCount={sectionItemsCount}
			totalMenuItemsCount={totalMenuItemsCount}
			isInMore={false}
			sectionFoldableBehaviour={sectionFoldableBehaviour}
		/>
	);
}
